<div class="custom-tooltip-content">
  <div class="tooltip-header">
    {{ substantiation?.name }}
  </div>

  <!-- Subtype -->
  <div class="tooltip-subtype" *ngIf="substantiation?.subtype">
    <b>SubType:</b>&nbsp; {{ substantiation.subtype }}
  </div>
  <!-- Geography -->
  <div class="tooltip-geography" *ngIf="substantiation?.geography">
    <b>Geography:</b>&nbsp; {{ substantiation.geography }}
  </div>
  <!-- description -->
  <!-- description -->
  <div class="tooltip-description" *ngIf="substantiation?.description">
    <b *ngIf="substantiation?.name !== 'Support Strategy'">Description:</b
    >&nbsp;
    <div class="tooltip-content" [innerHTML]="substantiation?.description">
      <!-- {{ sanitizeHTML(substantiation?.description) }} -->
    </div>
  </div>
  <!-- Details -->
  <div class="tooltip-description" *ngIf="substantiation?.details">
    <b>Details:</b>&nbsp; {{ sanitizeHTML(substantiation?.details) }}
  </div>
</div>
